import ValidationMessage from "./ValidationConstants";
class Rules {
  static rules = {
    state: [{ required: true, message: ValidationMessage.checkRequired }],
    city: [{ required: true, message: ValidationMessage.checkRequired }],
    communities: [{ required: true, message: ValidationMessage.checkRequired }],
    firstName: [
      { required: true, message: "First Name is required" },
      { max: 100, message: "First Name cannot be longer than 100 characters" },
      {
        min: 1,
        message: "First Name cannot be empty",
      },
      {
        pattern: /^[a-zA-Z\s]+$/,
        message: "First Name must contain only letters and spaces",
      },
    ],
    lastName: [
      { required: true, message: "Last Name is required" },
      { max: 100, message: "Last Name cannot be longer than 100 characters" },
      {
        min: 1,
        message: "Last Name cannot be empty",
      },
      {
        pattern: /^[a-zA-Z\s]+$/,
        message: "Last Name must contain only letters and spaces",
      },
    ],
    address: [
      { required: true, message: "Address is required" },
      { max: 2000, message: "Address cannot be longer than 2000 characters" },
      {
        min: 1,
        message: "Address cannot be empty",
      },
    ],
    cityName: [
      { required: true, message: ValidationMessage.checkRequired },
      {
        max: 100,
        message: ValidationMessage.checkLength,
      },
      {
        min: 1,
        message: "City cannot be empty",
      },
    ],
    stateName: [
      { required: true, message: ValidationMessage.checkRequired },
      {
        max: 100,
        message: ValidationMessage.checkLength,
      },
      {
        min: 1,
        message: "State cannot be empty",
      },
    ],
    zip: [
      { required: true, message: "Zip code is required" },
      {
        pattern: /^[0-9]{5}(?:-[0-9]{4})?$/,
        message: "Valid Zip code formats are: 12345 and 12345-6789",
      },
    ],
    phone: [
      { required: true, message: ValidationMessage.checkRequired },
      {
        pattern: /^\d{10}$/,
        message: ValidationMessage.checkValidPhone,
      },
    ],
    email: [
      { required: true, message: ValidationMessage.checkRequired },
      {
        pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: ValidationMessage.checkValidEmail,
      },
      {
        max: 150,
        message: ValidationMessage.checkLength,
      },
    ],
    residentKey: [
      { required: true, message: ValidationMessage.checkRequired },
      {
        min: 1,
        message: "Resident Key cannot be empty",
      },
    ],
    maintenanceLocation: [
      { required: true, message: ValidationMessage.checkRequired },
      {
        max: 1000,
        message: ValidationMessage.checkLength,
      },
      {
        min: 1,
        message: "Maintenance Location cannot be empty",
      },
    ],
    maintenanceConcern: [
      { required: true, message: ValidationMessage.checkRequired },
      {
        max: 5000,
        message: ValidationMessage.checkLength,
      },
      {
        min: 1,
        message: "Maintenance Concern cannot be empty",
      },
    ],
    files: [
      { required: true, message: ValidationMessage.checkRequired },
      {
        max: 1500,
        message: ValidationMessage.checkLength,
      },
    ],
    editorContent: [
      { required: true, message: ValidationMessage.checkRequired },
    ],
    radio: [{ required: true, message: ValidationMessage.checkRequired }],
  };
}
export default Rules;
